/**
 * @description usado para o formulário.
 */
export enum EPeriodoChuvoso {
	QUADRA_CHUVOSA = 'Quadra chuvosa',
	QUINTETO_CHUVOSO = 'Quinteto chuvoso',
	SEMESTRE_CHUVOSO = 'Semestre chuvoso',
}

export const PeriodoChuvosoMap = new Map<string, string>([
	['QUADRA_CHUVOSA', 'Quadra chuvosa'],
	['QUINTETO_CHUVOSO', 'Quinteto chuvoso'],
	['SEMESTRE_CHUVOSO', 'Semestre chuvoso'],
]);
